// @ts-nocheck
export const JWT_AUTH_TOKEN = "jwt-auth-token"

export const DEBOUNCE_TIME = 750

export const REACT_APP_API_DOMAIN = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
  : "http://localhost:8000"

export const REACT_APP_NSC_DOMAIN = process.env.REACT_APP_NSC_URL
  ? process.env.REACT_APP_NSC_URL
  : "http://localhost:8001"

/** Origin of the view CDN (view.scient.io): published model pages and the
 *  Trade Recon site. Unset in development, where the login flow issues no
 *  CloudFront signed cookies, so the nav hides what the browser could not open. */
export const REACT_APP_VIEW_DOMAIN: string | undefined = process.env.REACT_APP_VIEW_URL
